import React from 'react';
import * as S from './HeadLabelTooltip.styled';
export const HeadLabelTooltip = ({ title, description, type = 'text' }) => {
    return (React.createElement(S.Container, null,
        title && React.createElement(S.Title, null, title),
        React.createElement(S.Description, { type: type }, description)));
};
